



































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import HotkeyLegend from '@/layouts/gripper/hotkeys/HotkeyLegend.vue';
import OptionListItem from '@/layouts/gripper/components/OptionListItem.vue';
import {Option} from '@/types/gripper';
import HotkeyListener from '@/layouts/gripper/hotkeys/HotkeyListener.vue';

@Component({
  components: {HotkeyListener, OptionListItem, HotkeyLegend},
})

export default class LabelSideBar extends Vue {

  @Prop(Array) public allPossibleOptions!: Option[];
  @Prop(Object) public selectedLabel!: Option;
  @Prop(Object) public selectedFilterLabelOption!: Option;

  private indexInArray!: number;

  private created() {
    this.setDefaultOption();
  }

  // Check if there is a option and/or filter selected
  // to preserve the value through the pagination
  private setDefaultOption() {
    if (!this.selectedLabel) {
      this.changeOption(this.allPossibleOptions[0]);
      this.filterOption(this.selectedFilterLabelOption, false);
    } else if (!this.selectedFilterLabelOption) {
      this.changeOption(this.selectedLabel);
    } else {
      this.changeOption(this.selectedLabel);
      this.filterOption(this.selectedFilterLabelOption, false);
    }
  }

  private changeOption(option: Option) {
    this.$emit('onClickChangeOption', option);
    this.indexInArray = this.allPossibleOptions.findIndex((i: Option) => i.value === option.value);
  }

  private filterOption(option: Option, isResetPagination: boolean) {
    this.$emit('onClickFilterOption', option, isResetPagination);
  }

  private acceptAllPredictions() {
    this.$emit('acceptAllPredictions');
  }

  private keyListener(origin: string) {
    switch (origin) {
      case ']':
        // Check if we can traverse to a lower row
        if (this.indexInArray + 1 < this.allPossibleOptions.length) {
          this.changeOption(this.allPossibleOptions[this.indexInArray + 1]);
        }
        break;
      case '[':
        // Check if we can traverse to an upper row
        if (this.indexInArray > 0) {
          this.changeOption(this.allPossibleOptions[this.indexInArray - 1]);
        }
        break;
    }
  }

}

